import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=56223c8d&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=56223c8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56223c8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56223c8d')) {
      api.createRecord('56223c8d', component.options)
    } else {
      api.reload('56223c8d', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=56223c8d&scoped=true&", function () {
      api.rerender('56223c8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2F0UcIGRT4mck/JS/comp/DocBox.vue"
export default component.exports